export default "__VITE_ASSET__9d25af93__"